Browser = require 'lib/browser'
track = require 'debug/track'
WarningBannerView = require 'views/header/warning-banner-view'

t = require('views/internal/teacup-with-helpers')('browser_will_be_unsupported')

template = t.renderable ->
  t.p '.u-bottom', ->
    browser = Browser.browserVersionStr
    console.log(browser)
    if /^explorer-10/.test(browser)
      t.format 'trello-is-ending-support-for-ie-10'
      t.text ' '
      t.format 'please-upgrade-to-ie-11-or-newer', {
        url: 'https://support.microsoft.com/en-us/help/17621/internet-explorer-downloads'
      }
    else if /^safari-[678]/.test(browser)
      if /^safari-6/.test(browser)
        t.format 'trello-is-ending-support-for-safari-6'
      else if /^safari-7/.test(browser)
        t.format 'trello-is-ending-support-for-safari-7'
      else
        t.format 'trello-is-ending-support-for-safari-8'
      t.text ' '
      t.format 'please-upgrade-to-safari-9-or-newer', {
        url: 'https://support.apple.com/downloads/safari'
      }

module.exports = class BrowserWillBeUnsupportedView extends WarningBannerView
  events:
    'click a': (e) ->
      track("Unsupported Browser Banner", "Clicked Upgrade", Browser.browserVersionStr)

  render: ->
    @$el.html(template())
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/browser-will-be-unsupported-view.coffee